import React, {useEffect, useState} from "react";
import "./HealthConcernText.scss";
import TextInput from "../../Comon/TextInput/TextInput";
import HealthConcernRate from "../HealthConcernRate/HealthConcernRate";
import {updateSurveyData} from "../../../../redux/actions/survey";
import {Box} from "@mui/material";
import SurveyCheckboxOption from "../SurveyCheckboxOption/SurveyCheckboxOption";

const HealthConcernText = ({
                               themeColor,
                               topText,
                               headline,
                               text,
                               mandatory,
                               concernText,
                               setConcernText,
                               concernRate,
                               setConcernRate,
                               hasTextInput,
                               i18n,
                               leftOption,
                               rightOption,
                               options,
                               setOptions,
                               id,
                               hasRate = true,
                               hasSpecificRate,
                               singleSelect = false,
                               characterLimit = null,
                               separatedInParts = null,
                               newScale = false,
                               scaleVariant = "regular",
                               lastTimeRate = null,
                           }) => {

    const [parts, setParts] = useState([]);
    const updateOptions = (index, value, type) => {
        if (type === "text") {
            options[index].text = value;
        } else {
            options[index].selected = value;
            if (value === true && singleSelect) {
                options.forEach((o, optionIndex) => {
                    if (optionIndex !== index) {
                        o.selected = false;
                    }
                });
            }
        }

        setOptions(options);
    };

    useEffect(() => {
        if (separatedInParts) {
          setParts(Array(separatedInParts).fill(''));

          if (concernText.length > 0) {
            const partsArr = concernText.split(",");
            if (partsArr[0] !== undefined) {
              parts[0] = partsArr[0];
            }
            if (partsArr[1] !== undefined) {
              parts[1] = partsArr[1];
            }
            if (partsArr[2] !== undefined) {
              parts[2] = partsArr[2];
            }

            setParts([...parts]);
          }
        }
    }, [separatedInParts]);


    const updatePart = (value, index) => {
      parts[index] = value;
      setParts([...parts]);

      let newConcernText = "";

        if (parts[0] !== undefined) {
            newConcernText += parts[0];
        }
        if (parts[1] !== undefined) {
            newConcernText += (newConcernText ? ", " : "") + parts[1];
        }
        if (parts[2] !== undefined) {
            newConcernText += (newConcernText ? ", " : "") + parts[2];
        }

      setConcernText(newConcernText);



    }

    const getLastTimeRateColor = (rate) => {
        const redToGreenScale = [
            "rgb(166, 1, 35)",
            "rgb(212, 2, 40)",
            "rgb(237, 11, 10)",
            "rgb(244, 56, 4)",
            "rgb(249, 117, 2)",
            "rgb(248, 179, 0)",
            "rgb(250, 220, 1)",
            "rgb(205, 223, 15)",
            "rgb(140, 213, 33)",
            "rgb(69, 188, 55)",
            "rgb(23, 170, 64)",
        ];

        if (scaleVariant === "red_to_green") {
            return redToGreenScale[Math.max(0, Math.min(10, Number(rate)))];
        }

        if (scaleVariant === "green_to_red") {
            const greenToRedScale = [...redToGreenScale].reverse();
            return greenToRedScale[Math.max(0, Math.min(10, Number(rate)))];
        }

        return "#f5a623";
    };

    const renderDescription = () => {
        const mandatoryText = mandatory ? ` ${i18n.t("mandatoryHealthConcern")}` : "";

        if (
            lastTimeRate === null ||
            lastTimeRate === undefined ||
            text === null ||
            text === undefined
        ) {
            return <>{text}{mandatoryText}</>;
        }

        const stringText = String(text);
        const rateString = String(lastTimeRate);
        const ratePosition = stringText.indexOf(rateString);

        if (ratePosition === -1) {
            return <>{stringText}{mandatoryText}</>;
        }

        const beforeRate = stringText.slice(0, ratePosition);
        const afterRate = stringText.slice(ratePosition + rateString.length);

        return (
            <>
                {beforeRate}
                <span
                    className="lastTimeRateBadge"
                    style={{backgroundColor: getLastTimeRateColor(lastTimeRate)}}
                >
                    {rateString}
                </span>
                {afterRate}
                {mandatoryText}
            </>
        );
    };

    return (
        <div className="HealthConcernText" id={id}>
            {
                topText && <div className={"healthTopHeadline"} style={{borderColor: themeColor}}>
                    {topText}
                </div>
            }

            {
                headline && <div className={"healthHeadline"}>{headline}</div>
            }

            {
                renderDescription() && <div className={"healthDescription"}>
                    {renderDescription()}
                </div>
            }

            {hasTextInput === true ? (
                    separatedInParts && parts ?
                        parts.map((part, index) => {
                            return <div className={"healthTextContainer"}>
                                <TextInput
                                    maxlength={characterLimit}
                                    rows={3}
                                    label={""}
                                    mode={"greyWithBorder"}
                                    placeholder={i18n.t("personNumber") + (index + 1)}
                                    type={"textarea"}
                                    specialClass={"smallTextSurveyInput"}
                                    setValue={(value) => updatePart(value, index)}
                                    value={part}
                                    errorMessage={
                                        characterLimit && part.length > (characterLimit - 1)
                                            ? characterLimit + " " + i18n.t("characterLimitations")
                                            : null
                                    }
                                />

                            </div>
                        })
                        :
                        <div className={"healthTextContainer"}>
                            <TextInput
                                maxlength={characterLimit}
                                rows={3}
                                label={""}
                                mode={"greyWithBorder"}
                                placeholder={i18n.t("typeHere")}
                                type={"textarea"}
                                setValue={setConcernText}
                                value={concernText}
                                errorMessage={
                                    characterLimit && concernText.length > (characterLimit - 1)
                                        ? characterLimit + " " + i18n.t("characterLimitations")
                                        : null
                                }
                            />
                        </div>
                ) :
                (
                    <div className={"noTextSeparator"}/>
                )
            }
            {options == null && hasRate ? (
                <div
                    className={
                        hasSpecificRate
                            ? "healthConcernSpecificRatesContainer"
                            : "healthConcernRatesContainer"
                    }
                >
                    <HealthConcernRate
                        newScale={newScale}
                        scaleVariant={scaleVariant}
                        rate={concernRate}
                        hasSpecificRate={hasSpecificRate}
                        themeColor={themeColor}
                        i18n={i18n}
                        leftOption={leftOption}
                        rightOption={rightOption}
                        setRate={(value) => setConcernRate(value)}
                    />
                </div>
            ) : null}
            {options
                ? options
                    .sort((a, b) => a.id - b.id)
                    .map((option, index) => {
                        return (
                            <div className={"optionContainer"} key={index}>
                                <SurveyCheckboxOption
                                    text={option.text}
                                    setText={(value) => updateOptions(index, value, "text")}
                                    selected={option.selected}
                                    isOther={option.isOther}
                                    setSelected={(value) =>
                                        updateOptions(index, value, "selected")
                                    }
                                />
                            </div>
                        );
                    })
                :
                null
            }
        </div>
    )
        ;
};

export default HealthConcernText;
